// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  display: flex;
  flex-direction: column;
  margin: 0;
  background-color: #00696B;
  width: 100%;
  height: 6rem;
  position: fixed;
  z-index: 1000;
}
.navigation ul {
  list-style: none;
  width: 100%;
  top: 0;
  padding-left: 1rem;
  margin: 0;
}
.navigation ul li {
  display: inline-flex;
  width: 9.375rem;
  height: 4.5rem;
  margin: 0.75rem 0.5rem;
  text-align: center;
}
.navigation ul li a {
  background-color: #00696B;
  color: #fff;
  width: 100%;
  border: 0;
  border-radius: 0.75rem;
  cursor: pointer;
  opacity: 0.8;
  font-weight: 700;
  font-size: 1rem;
  padding-top: 1.5rem;
  text-decoration: none;
}
.navigation ul li a .counter {
  border-radius: 0.5rem;
  padding: 0px 0.625rem;
  margin-left: 0.625rem;
  margin-top: 2px;
  font-weight: 700;
  font-size: 0.75rem;
  letter-spacing: 0.094rem;
  height: -moz-fit-content;
  height: fit-content;
  background: #003738;
}
.navigation ul li a:hover {
  background: #005052;
  opacity: 1;
}
.navigation ul li a.active {
  background: #003738;
  cursor: auto;
  opacity: 1;
}
.navigation ul li a.active .counter {
  background: #000505;
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.scss","webpack://./src/style/Variables.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBCMoB;EDLpB,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAIF;AAFE;EACE,gBAAA;EACA,WAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;AAIJ;AAHI;EACE,oBAAA;EACA,eAAA;EACA,cChBY;EDiBZ,sBAAA;EACA,kBAAA;AAKN;AAJM;EACE,yBCbc;EDcd,WCLM;EDMN,WAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AAMR;AAJQ;EACE,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,mBAAA;AAMV;AAHQ;EACE,mBAAA;EACA,UAAA;AAKV;AAFQ;EACE,mBAAA;EACA,YAAA;EACA,UAAA;AAIV;AAFU;EACE,mBAAA;AAIZ","sourcesContent":["@import \"../../../src/style/Variables.module.scss\";\n.navigation {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  background-color: $theme-primary-color;\n  width: 100%;\n  height: 6rem;\n  position: fixed;\n  z-index: 1000;\n\n  ul {\n    list-style: none;\n    width: 100%;\n    top: 0;\n    padding-left: 1rem;\n    margin: 0;\n    li {\n      display: inline-flex;\n      width: 9.375rem;\n      height: $tabpanel-height;\n      margin: 0.75rem 0.5rem;\n      text-align: center;\n      a {\n        background-color: $theme-primary-color;\n        color: $white-color;\n        width: 100%;\n        border: 0;\n        border-radius: 0.75rem;\n        cursor: pointer;\n        opacity: 0.8;\n        font-weight: 700;\n        font-size: 1rem;\n        padding-top: 1.5rem;\n        text-decoration: none;\n\n        .counter {\n          border-radius: 0.5rem;\n          padding: 0px 0.625rem;\n          margin-left: 0.625rem;\n          margin-top: 2px;\n          font-weight: 700;\n          font-size: 0.75rem;\n          letter-spacing: 0.094rem;\n          height: fit-content;\n          background: darken($theme-primary-color, 10%);\n        }\n\n        &:hover {\n          background: darken($theme-primary-color, 5%);\n          opacity: 1;\n        }\n\n        &.active {\n          background: darken($theme-primary-color, 10%);\n          cursor: auto;\n          opacity: 1;\n\n          .counter {\n            background: darken($theme-primary-color, 20%);\n          }\n        }\n      }\n    }\n  }\n}\n","$light-grey-background: rgb(242, 246, 249);\n$dark-grey-background: rgb(204, 204, 204);\n\n$header-height: 5.125rem;\n$tabpanel-height: 4.5rem;\n$tabpanel-button-height: 3.5rem;\n$main-area-top-padding: 8.625rem;\n$size-buttons-top: 12rem;\n$main-area-height: calc(100vh - 8.625rem);\n\n// Colors\n$theme-primary-color: #00696B;\n$theme-secondary-color: #21decc; //#035a57\n$theme-background-color: #F0F4F5;\n$theme-background-color-attachment-container: #F0F4F5;\n\n$black-color: #212121;\n$dark-grey-color: #666;\n$medium-grey-color: #9e9e9e;\n$light-grey-color: #d8d8d8;\n$white-color: #fff;\n\n$alert-danger: #f6423c;\n$alert-warning: #facc00;\n$alert-success: #156631;\n$alert-unknown: grey;\n\n$modal-card-title-color: #005457;\n$risks-button: #06a8a2;\n$alert-warning: #facc00;\n$status-color-draft: #f3a01b;\n$status-color-signed: #00b03b;\n\n:export {\n  themeBgColorExpandButton: $theme-background-color;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeBgColorExpandButton": `#F0F4F5`
};
export default ___CSS_LOADER_EXPORT___;
